// removed by extract-text-webpack-plugin
module.exports = {"wizardContainer":"_1x9VzIBCzOPZPEMnVr-Dtb","wizard":"OzR4u0A9REApIddQ9sltu","items":"_1R1caRlGu2ugqf_21EvMEf"};


//////////////////
// WEBPACK FOOTER
// ./app/client/bundles/EventSubmission/components/Wizard.scss
// module id = 1214
// module chunks = 0